import { SVGProps } from 'react';

const FilterIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0001 3.50002V1.16669M11.0001 3.50002C10.3812 3.50002 9.78775 3.74585 9.35017 4.18344C8.91258 4.62102 8.66675 5.21452 8.66675 5.83335C8.66675 6.45219 8.91258 7.04568 9.35017 7.48327C9.78775 7.92085 10.3812 8.16669 11.0001 8.16669M11.0001 3.50002C11.6189 3.50002 12.2124 3.74585 12.65 4.18344C13.0876 4.62102 13.3334 5.21452 13.3334 5.83335C13.3334 6.45219 13.0876 7.04568 12.65 7.48327C12.2124 7.92085 11.6189 8.16669 11.0001 8.16669M11.0001 8.16669V19.8334M4.00008 17.5C4.61892 17.5 5.21241 17.2542 5.65 16.8166C6.08758 16.379 6.33342 15.7855 6.33342 15.1667C6.33342 14.5478 6.08758 13.9544 5.65 13.5168C5.21241 13.0792 4.61892 12.8334 4.00008 12.8334M4.00008 17.5C3.38124 17.5 2.78775 17.2542 2.35017 16.8166C1.91258 16.379 1.66675 15.7855 1.66675 15.1667C1.66675 14.5478 1.91258 13.9544 2.35017 13.5168C2.78775 13.0792 3.38124 12.8334 4.00008 12.8334M4.00008 17.5V19.8334M4.00008 12.8334V1.16669M18.0001 17.5C18.6189 17.5 19.2124 17.2542 19.65 16.8166C20.0876 16.379 20.3334 15.7855 20.3334 15.1667C20.3334 14.5478 20.0876 13.9544 19.65 13.5168C19.2124 13.0792 18.6189 12.8334 18.0001 12.8334M18.0001 17.5C17.3812 17.5 16.7878 17.2542 16.3502 16.8166C15.9126 16.379 15.6667 15.7855 15.6667 15.1667C15.6667 14.5478 15.9126 13.9544 16.3502 13.5168C16.7878 13.0792 17.3812 12.8334 18.0001 12.8334M18.0001 17.5V19.8334M18.0001 12.8334V1.16669"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterIcon;
